// extracted by mini-css-extract-plugin
var _1 = "MKfan";
var _2 = "KJGWl";
var _3 = "PqjFn";
var _4 = "druXb";
var _5 = "YbE0I";
var _6 = "FI8ZL";
export { _1 as "decorate", _2 as "l", _3 as "ml", _4 as "mr", _5 as "topBorder", _6 as "view" }
